
import { Modal } from 'antd'
import ReCAPTCHA from 'react-google-recaptcha'
import { useState } from 'react'
import { SITE_KEY } from 'src/configs/API'


export default function RecaptchaModal({
  open,
  onSuccess,
  onCancel,
  title = 'Xác nhận'
}) {
  const [token, setToken] = useState(null)

  const handleOk = () => {
    if (!token) return
    onSuccess(token)
    setToken(null)
  }

  const handleCancel = () => {
    setToken(null)
    onCancel()
  }

  return (
    <Modal
      title={title}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okButtonProps={{ disabled: !token }}
      destroyOnClose
      width={350}
      okText='Tra cứu'
      zIndex={90}
      maskClosable={false}
    >
      <ReCAPTCHA
        sitekey={SITE_KEY}
        onChange={setToken}
      />
    </Modal>
  )
}
